module.exports = __webpack_public_path__ + "assets/7a310694f31c6dcea8096ca16975c6ca.mp3";


/*****************
 ** WEBPACK FOOTER
 ** ./public-src/sounds/buttons/coins/bet-3.mp3
 ** module id = 220
 ** module chunks = 0
 **/